module.exports = __webpack_public_path__ + "c668a27c0dfba50c46527a2fd13331cd.svg";